var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8VanuatuCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M6,24.005c0.001,6.053,0.692,11.477,4.941,15.144C14.445,42.171,19.008,44,23.999,44h0.002 C35.046,43.999,44,35.045,44,24L6,24.005z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M44,24c0-11.046-8.954-20-20-20c-5.004,0-9.578,1.837-13.085,4.874 C6.681,12.541,6.002,17.955,6,23.995L4,24H44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M10.995,39.176L27.2,28h16.398C43.861,26.707,44,25.37,44,24s-0.139-2.707-0.402-4H27.2 L10.995,8.824C6.72,12.491,4.002,17.921,4,23.994v0.012C4.002,30.079,6.72,35.509,10.995,39.176z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M13.369,24.031c0,0-0.509,1.87-2.519,1.87s-2.546-1.789-2.546-2.548 c0-1.026,0.884-2.711,2.68-2.711s3.055,1.789,3.055,3.226s-1.045,3.47-3.162,3.47c0,1.084,0,1.87,0,1.87s4.716-0.325,4.716-5.259 c0-4.5-4.073-4.744-4.556-4.744c-0.604,0-3.913,0.379-3.913,4.012c0,3.361,3.189,3.578,3.698,3.578 C11.199,26.795,13.369,26.524,13.369,24.031z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M10.225,21.943c0,0,1.787,1.211,2.305,2.024c-0.018,0.398-0.036,0.669-0.036,0.669l-0.59-0.145 c0,0-1.018-1.699-1.894-2.187C9.135,21.817,9.85,21.745,10.225,21.943z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M11.88,21.943c0,0-1.787,1.211-2.305,2.024c0.018,0.398,0.036,0.669,0.036,0.669l0.59-0.145 c0,0,1.018-1.699,1.894-2.187S12.255,21.745,11.88,21.943z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M9.35,37.583l17.762-12.25h16.82C43.962,24.891,44,24.45,44,24s-0.038-0.891-0.067-1.333h-16.82 L9.35,10.417c-0.594,0.641-1.149,1.316-1.656,2.03L24.446,24L7.693,35.554C8.2,36.268,8.756,36.943,9.35,37.583z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8VanuatuCircular);
export default __webpack_public_path__ + "static/media/icons8-vanuatu-circular.e3a29a7ca4f74e469b82f53158b8982c.svg";
export { ForwardRef as ReactComponent };